import { useUserLimitsService } from '../services/userLimitsService'
import { UserLimits } from '../components/includes/UserLimits'

const userLimitService = useUserLimitsService()

export default {
    state: {
        limits: null,
    },
    actions: {
        async fetchLimits ({ commit }) {
            const data = await userLimitService.getLimits()
            commit('setUserLimits', (new UserLimits(data)))
        }
    },
    mutations: {
        setUserLimits (state, limits) {
            state.limits = limits
        }
    },
    getters: {
        getLimits (state) {
            return state.limits
        }
    }
}
